{
    "FullName": "Nome completo:",
    "FullNamePlaceholder": "[Nome completo non specificato]",
    "UsernameHint": "Il nome utente non deve necessariamente essere un indirizzo e-mail, ma deve essere identificabile in modo univoco e sensibile alle maiuscole e alle minuscole",
    "UsernameEditHint": "Quando si modifica un nome utente, la password deve essere reinserita.",
    "Email": "E-mail:",
    "EmailPlaceholder": "esempio@dominio.com",
    "EmailHint": "Dove vengono inviati i messaggi e-mail generati automaticamente. (e-mail di benvenuto per nuovi utenti, reimpostazione di password e rapporti programmati)",
    "Defaultlanguage": "Lingua dell'e-mail:",
    "DefaultlanguageHint": "Imposta la lingua predefinita per la piattaforma e le e-mail corrispondenti.",
    "Passwordchange": "È richiesta la modifica della password:",
    "Welcomeemail": "Inviare un'e-mail di benvenuto:",
    "WelcomeemailHelp": "Questa opzione è disponibile quando sono stati inseriti un indirizzo e-mail e una password validi e l'impostazione Modifica password richiesta è attivata.",
    "NameValidation": "Il nome completo non deve superare i 100 caratteri",
    "UsernameRequiredValidation": "Il nome utente non deve essere vuoto",
    "EmailPatternValidation": "Inserire un indirizzo e-mail valido",
    "PasswordLengthValidation": "La password è troppo corta",
    "PasswordRequiredValidation": "La password non deve essere vuota",
    "PasswordStrengthValidation": "La password non è abbastanza forte (assicurarsi di includere lettere maiuscole e minuscole e numeri).",
    "UserDetailsLanguage_Username": "Nome utente:",
    "UserDetailsLanguage_Password": "Password:",
    "UserDetailsLanguage_PasswordPlaceholder": "--------",
    "NAME": "UserDetailsLanguage",
    "UsernameIDOnTelSysHint": "Il nome utente non può essere modificato per questo tipo di abbonamento. Deve corrispondere al nome utente della piattaforma di telefonia.",
    "EmailRequiredValidation": "L'indirizzo e-mail non deve essere vuoto",
    "UserDetailsLanguage_MFA_Label": "Abilitare l'MFA:",
    "UserDetailsLanguage_MFAHelp": "Abilitare l'autenticazione a più fattori (MFA) significa che all'utente verrà richiesto di inserire un codice dall'app Authenticator al momento dell'accesso.",
    "Timezone_Title": "Fuso orario:",
    "UserDetailsLanguage_CXIntegration": "Integrazione CX:",
    "UsernameMustBeSetFromDeviceValidation": "Per ottenere il nome utente per questo tipo di utente, assicurati che il dispositivo sia impostato nella scheda delle autorizzazioni"
}